/**
 * Maps Fluent UI MDL2 icon names (used in systemAdminNavigation.ts)
 * to Collabspace CwIcon registry names.
 *
 * This lets the nav data model stay untouched while the renderer
 * switches from Fluent's icon font to stroke-based SVG.
 */
const navIconMap: Record<string, string> = {
    SpeedHigh: 'dashboard',
    EMI: 'tenants',
    Group: 'users',
    AppIconDefault: 'apps',
    CRMServices: 'licensing',
    ComplianceAudit: 'audits',
    BarChartVertical: 'analytics',
    Settings: 'settings',
    Diagnostic: 'diagnostics',
};

const DEFAULT_NAV_ICON = 'doc';

/**
 * Resolves a nav link's `icon` field (Fluent MDL2 name or CwIcon name)
 * to a CwIcon name. Falls back to 'doc' for unknown icons.
 */
export function resolveNavIcon(iconName?: string): string {
    if (!iconName) return DEFAULT_NAV_ICON;
    if (navIconMap[iconName]) return navIconMap[iconName];
    return iconName;
}
